@if (native()) {
  <label class="lang-select">
    <app-icon class="lang-select-glyph" name="globe" [size]="16" />
    <select
      class="lang-select-input"
      [attr.aria-label]="'languageSwitcher.label' | translate"
      (change)="onNativeChange($event)">
      @for (lang of languages; track lang) {
        <option [value]="lang" [selected]="currentLang === lang">{{ 'languageSwitcher.' + lang | translate }}</option>
      }
    </select>
    <app-icon class="lang-select-caret" name="chevron-down" [size]="14" />
  </label>
} @else {
  <app-dropdown class="lang-switcher" #langDropdown="appDropdown">
    <button
      dropdownTrigger
      type="button"
      class="lang-trigger"
      (click)="langDropdown.toggle()"
      [attr.aria-expanded]="langDropdown.open()"
      [attr.aria-label]="'languageSwitcher.triggerLabel' | translate: { lang: currentLang }">
      <span class="lang-trigger-code">{{ currentLang }}</span>
      <app-icon class="caret" name="chevron-down" [size]="14" />
    </button>
    <div dropdownPanel class="lang-panel" [class.lang-panel--open]="langDropdown.open()">
      @for (lang of languages; track lang) {
        <button
          type="button"
          class="lang-row"
          [class.lang-row--active]="currentLang === lang"
          (click)="setLang(lang); langDropdown.close()">
          {{ 'languageSwitcher.' + lang | translate }}
        </button>
      }
    </div>
  </app-dropdown>
}
